/**
 * Determines the current environment based on the API address
 * @returns 'dev' | 'stage' | 'prod' | null
 */
export function getEnvironment(): 'dev' | 'stage' | 'prod' | null {
  const apiAddress = process.env.REACT_APP_API_ADDRESS || '';
  
  // Check if API address contains environment indicators
  if (apiAddress.includes('.dev.') || apiAddress.includes('/dev/')) {
    return 'dev';
  }
  
  if (apiAddress.includes('.stage.') || apiAddress.includes('/stage/')) {
    return 'stage';
  }
  
  // Default to prod if no environment indicators found
  // or if explicitly set via environment variable
  if (process.env.REACT_APP_ENVIRONMENT) {
    const env = process.env.REACT_APP_ENVIRONMENT.toLowerCase();
    if (env === 'dev' || env === 'stage' || env === 'prod') {
      return env as 'dev' | 'stage' | 'prod';
    }
  }
  
  // If no indicators found, assume production (no badge needed)
  return null;
}
